module.exports = __webpack_public_path__ + "img/pt_Beta Digitis - Gif.4dab71bf.gif";